import { lazyWithSuspense } from '~/utilities/lazyWithSuspense';

export const LiveStreamAudienceRouter = lazyWithSuspense(async () => import('./RouterPage'));
